export const toDictionary = <T, TValue>(items: T[], key: (item: T) => string, value: (item: T) => TValue) => {
  const dict: Record<string, TValue> = {};
  for (let i = 0; i < items.length; i++) {
    dict[key(items[i])] = value(items[i]);
  }
  return dict;
};
